import styled from 'styled-components'

export const GroupStyled = styled.div`
  & > div {
    padding: 0;
  }
`
